/**
 * Name: AlertBox - JS komponenta k extenzi AlertBox
 * Description: Informacni box/pruh - komponenta se zobrazi v pripade, kdy v cookie neexistuje zaznam s prislusnym id.
 * Komponenta obsahuje subwidget pro zavreni, ktery skryje aktualni zpravu a do cookie ulozi prislusne id.
 */
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import cookie from 'js-cookie';

const fragments = {
  CLOSE: '[data-fragment="AlertBox.close"]',
};

const COOKIE_KEY = 'alertBoxSeen';

export default class AlertBox extends WebComponent {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  didMount() {
    this.on('click', fragments.CLOSE, this.handleClick);

    this.createCookie(COOKIE_KEY);
    this.loadAlerts();
  }

  handleClick() {
    const cookieText = cookie.get(COOKIE_KEY);
    const idArray = cookieText ? cookieText.split(',') : [];

    idArray.push(this.props.alertId);

    cookie.set(COOKIE_KEY, idArray.toString(), {expires: 365.2425 * 5});

    this.element.classList.remove('show');
  }

  loadAlerts() {
    const cookieText = cookie.get(COOKIE_KEY);
    const alertsToHide = cookieText ? cookieText.split(',') : [];
    if (!alertsToHide.includes(this.props.alertId)) {
      this.element.classList.add('show');
    }
  }

  createCookie(key) {
    if (!cookie.get(key)) cookie.set(key, '');
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/AlertBox.js